<p-toast position="bottom-right"></p-toast>
<div class="service-details call-overview">
  <h1 class="heading" *ngIf="disputeDetails">
    {{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.DISPUTE_ID' | translate }}: {{ disputeDetails.uid }}
  </h1>

  <div class="row g-3">
    <div class="col-md-6 col-sm-12">
      <div class="bg-white rounded-2 shadow-sm p-3 dispute-overview h-100">
        <ng-container *ngIf="disputeDetails; else noDisputeMessage">
          <div class="dispute-card">
            <div class="controls-container">
              <h4 class="table-heading">
                {{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW_TABLE_HEADING' | translate }}
              </h4>
            </div>
            <form #statusForm="ngForm">
              <table class="table">
                <tr>
                  <td>{{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.DISPUTE_ID' | translate }}</td>
                  <td>{{ disputeDetails.uid }}</td>
                </tr>
                <tr>
                  <td>{{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.DISPUTE_TYPE' | translate }}</td>
                  <td>{{ disputeDetails.disputeType }}</td>
                </tr>
                <tr>
                  <td>{{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.RAISED_BY' | translate }}</td>
                  <td>{{ disputeDetails.raisedByName }}</td>
                </tr>
                <tr>
                  <td>{{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.RAISED_ON' | translate }}</td>
                  <td>
                    {{
                      disputeDetails.createdOn
                        ? getConvertedDate(disputeDetails.createdOn || '')
                        : ''
                    }}
                  </td>
                </tr>
                <tr>
                  <td>{{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.USER_TYPE' | translate }}</td>
                  <td>
                    {{ disputeDetails.userType }}
                  </td>
                </tr>
                <tr>
                  <td>{{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.LAST_UPDATED_ON' | translate }}</td>
                  <td>
                    {{
                      disputeDetails.createdOn
                        ? getConvertedDate(disputeDetails.modifiedOn || '')
                        : ''
                    }}
                  </td>
                </tr>
                <tr>
                  <td>{{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.STATUS' | translate }}</td>
                  <td>
                    <p-dropdown
                      class="custom-dropdown"
                      name="disputeStatus"
                      [(ngModel)]="disputeDetails.disputeStatus"
                      [options]="disputeStatuses"
                      optionLabel="status"
                      optionValue="status"
                      required
                      [ngClass]="{
                        'status-success': disputeDetails.disputeStatus === statuses.RESOLVED,
                        'status-danger': disputeDetails.disputeStatus === statuses.OPEN,
                        'status-warning': disputeDetails.disputeStatus === statuses.UNDER_REVIEW,
                      }"
                      #statusCtrl="ngModel"
                    ></p-dropdown>
                  </td>
                </tr>

                <!-- Row for comment and button -->
                <tr>
                  <td class="transparent-background"></td>
                  <td>
                    <div class="update-comment bg-white rounded">
                      <label for="comment" class="form-label">
                        <span class="fw-normal">{{
                          'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.COMMENT' | translate
                        }}</span>
                        <span class="text-muted">
                          ({{
                            'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.FOR_STATUS_UPDATE' | translate
                          }})
                        </span>
                      </label>

                      <textarea
                        id="comment"
                        name="disputeComment"
                        class="form-control reply-box"
                        rows="3"
                        [(ngModel)]="disputeComment"
                        required
                        #disputeCommentCtrl="ngModel"
                      ></textarea>

                      <div class="text-end mt-2">
                        <button
                          type="button"
                          class="btn btn-custom-green"
                          [disabled]="!statusForm.valid || !statusForm.dirty"
                          (click)="updateDisputeStatus(disputeDetails, disputeComment)"
                        >
                          {{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.UPDATE' | translate }}
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </form>
          </div>
        </ng-container>
        <ng-template #noDisputeMessage>
          <h4 class="table-heading">
            {{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW_TABLE_HEADING' | translate }}
          </h4>
          <table class="table">
            <tbody>
              <tr>
                <td colspan="2" class="no-data-available">
                  {{ 'COMMON.NO_AVAILABLE' | translate }}
                </td>
              </tr>
            </tbody>
          </table>
        </ng-template>
      </div>
    </div>

    <div class="col-md-6 col-sm-12">
      <div class="user-comment-container bg-white rounded-2 shadow-sm h-100">
        <div class="user-comments">
          <label class="form-label">
            {{ 'SERVICE_DETAILS_PAGE.COMMENT_BY_USER' | translate }}</label
          >
          <div id="user-comment" class="user-comment-box">
            <ng-container *ngIf="disputeDetails?.description">
              {{ disputeDetails.description }}
            </ng-container>
          </div>
        </div>

        <div class="reply-box mt-2">
          <label for="reply" class="form-label">
            {{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.REPLY' | translate }}:</label
          >
          <textarea
            id="reply"
            name="reply"
            class="form-control reply-box"
            rows="4"
            [(ngModel)]="reply"
          ></textarea>
        </div>
        <div class="text-end mt-2">
          <button
            type="button"
            class="btn btn-custom-green"
            (click)="updateDisputeStatus(disputeDetails, reply)"
          >
            {{ 'SERVICE_DETAILS_PAGE.DISPUTE_OVERVIEW.UPDATE' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
